import { ThemeEvents } from "@theme/events";

class EscapeDeliveryTime extends HTMLElement {
  connectedCallback() {
    this.messageEl = this.querySelector("[data-delivery-message]");
    this.variantData = this.#parseVariantData();
    this.settings = this.#parseSettings();
    this.#section = this.closest(".shopify-section, dialog");

    this.#section?.addEventListener(
      ThemeEvents.variantUpdate,
      this.#onVariantUpdate,
    );
    this.#updateFromCurrentVariant();
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.#onVariantUpdate,
    );
  }

  #section = null;

  #parseVariantData() {
    try {
      return JSON.parse(this.dataset.variants || "{}");
    } catch {
      return {};
    }
  }

  #parseSettings() {
    try {
      return JSON.parse(this.dataset.settings || "{}");
    } catch {
      return {};
    }
  }

  #onVariantUpdate = (event) => {
    const productId = this.dataset.productId;
    if (
      event.detail?.data?.productId &&
      productId &&
      event.detail.data.productId !== productId
    ) {
      return;
    }

    const variantId = event.detail?.resource?.id;
    if (variantId) {
      this.#updateMessage(String(variantId));
    }
  };

  #updateFromCurrentVariant() {
    const root = this.closest(
      ".product-details, product-form-component, .shopify-section",
    );
    const input = root?.querySelector('input[name="id"]');
    const variantId = input?.value || this.dataset.initialVariant;
    if (variantId) {
      this.#updateMessage(String(variantId));
    }
  }

  #stripHtml(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html || "";
    return temp.textContent || temp.innerText || html || "";
  }

  #updateMessage(variantId) {
    if (!this.messageEl) return;

    const variant = this.variantData[variantId];
    if (!variant || variant.inventoryManagement !== "shopify") {
      this.hidden = true;
      return;
    }

    let html = "";
    let status = "";
    let shouldShow = true;

    if (variant.quantity > 0 && variant.available) {
      status = "in_stock";
      const message = this.#stripHtml(this.settings.inStockMessage);
      html = `${this.settings.inStockIcon || ""} ${message}`.trim();
    } else if (
      variant.quantity <= 0 &&
      variant.inventoryPolicy === "continue"
    ) {
      status = "backorder";
      const message = this.#stripHtml(this.settings.outOfStockMessage);
      html = `${this.settings.outOfStockIcon || ""} ${message}`.trim();
    } else {
      shouldShow = false;
    }

    if (shouldShow) {
      this.messageEl.innerHTML = html;
      this.dataset.status = status;
      this.hidden = false;
    } else {
      this.hidden = true;
    }
  }
}

if (!customElements.get("escape-delivery-time")) {
  customElements.define("escape-delivery-time", EscapeDeliveryTime);
}
